// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3a6adf7f","239":"0321d81c","732":"2e721e01"}[chunkId] + ".chunk.js";
};